import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            {aboutInfo.title}
          </h2>
          <div className="w-12 h-0.5 bg-primary-500 mx-auto rounded-full"></div>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 md:gap-10 items-center">
          <div className="w-full lg:w-1/2">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20home%20theater%20setup%20with%20large%20screen%20displaying%20abstract%20cinematic%20imagery%2C%20warm%20ambient%20lighting%2C%20comfortable%20modern%20living%20room%2C%20cozy%20atmosphere%2C%20soft%20golden%20tones%2C%20premium%20entertainment%20aesthetic%2C%20no%20people%2C%20rich%20textures%2C%20cinematic%20color%20grading%2C%20professional%20interior%20photography&width=800&height=500&seq=jiubo-about-visual&orientation=landscape"
              alt="久播影院 - 高清免费在线观影平台品牌介绍"
              className="w-full rounded-xl object-cover"
            />
          </div>
          <div className="w-full lg:w-1/2 space-y-4">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutInfo.content1}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutInfo.content2}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutInfo.content3}
            </p>
            <div className="flex items-center gap-4 pt-2 flex-wrap">
              <div className="flex items-center gap-1.5 text-foreground-600 text-xs md:text-sm">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                <span>全免费</span>
              </div>
              <div className="flex items-center gap-1.5 text-foreground-600 text-xs md:text-sm">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                <span>免注册</span>
              </div>
              <div className="flex items-center gap-1.5 text-foreground-600 text-xs md:text-sm">
                <i className="ri-checkbox-circle-line text-primary-500"></i>
                <span>无广告</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}